/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentApplicationResponse
 */
export interface TournamentApplicationResponse {
    /**
     * Always false under the corroboration flow — screenshots are stored as evidence, never applied to the bracket at upload
     * @type {boolean}
     * @memberof TournamentApplicationResponse
     */
    applied: boolean;
    /**
     * What happened to the photo (stored as match evidence, match not readied, ...)
     * @type {string}
     * @memberof TournamentApplicationResponse
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentApplicationResponse
     */
    tournamentId: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentApplicationResponse
     */
    bracketMatchId?: string;
    /**
     * 
     * @type {number}
     * @memberof TournamentApplicationResponse
     */
    team1Score?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentApplicationResponse
     */
    team2Score?: number;
    /**
     * 
     * @type {string}
     * @memberof TournamentApplicationResponse
     */
    winnerTeamId?: string;
}

/**
 * Check if a given object implements the TournamentApplicationResponse interface.
 */
export function instanceOfTournamentApplicationResponse(value: object): value is TournamentApplicationResponse {
    if (!('applied' in value) || value['applied'] === undefined) return false;
    if (!('tournamentId' in value) || value['tournamentId'] === undefined) return false;
    return true;
}

export function TournamentApplicationResponseFromJSON(json: any): TournamentApplicationResponse {
    return TournamentApplicationResponseFromJSONTyped(json, false);
}

export function TournamentApplicationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentApplicationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'applied': json['applied'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'tournamentId': json['tournamentId'],
        'bracketMatchId': json['bracketMatchId'] == null ? undefined : json['bracketMatchId'],
        'team1Score': json['team1Score'] == null ? undefined : json['team1Score'],
        'team2Score': json['team2Score'] == null ? undefined : json['team2Score'],
        'winnerTeamId': json['winnerTeamId'] == null ? undefined : json['winnerTeamId'],
    };
}

export function TournamentApplicationResponseToJSON(json: any): TournamentApplicationResponse {
    return TournamentApplicationResponseToJSONTyped(json, false);
}

export function TournamentApplicationResponseToJSONTyped(value?: TournamentApplicationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applied': value['applied'],
        'reason': value['reason'],
        'tournamentId': value['tournamentId'],
        'bracketMatchId': value['bracketMatchId'],
        'team1Score': value['team1Score'],
        'team2Score': value['team2Score'],
        'winnerTeamId': value['winnerTeamId'],
    };
}

